import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const TextBox = props => {
  const { txtLabel ,handleChange,countChar, errors, touched,name, handleBlur, values, maxLenghtNum} = props;
  return (
    <div id="TextBox" style={{ width: '100%' }}>
      {/*   <textarea
        maxLength={201}
        placeholder="What's happening?"
        onChange={props.countChar}
      /> */}

      <TextField
        label={txtLabel}
        id={name}
        multiline={true}
        rows="5"
        value={values}
        variant="outlined"
        onBlur={handleBlur}
        helperText={touched && errors ? errors : ''}
        error={touched && errors ? true : false}
              fullWidth
        onChange={(event) => {
         
  handleChange(event);
  countChar(event)
          }}
        inputProps={{

          maxLength: maxLenghtNum,
        }}
        /* value={values.email}
        helperText={touched.email && errors.email ? errors.email : ''}
        error={touched.email && errors.email ? true : false} */
        fullWidth
        style={{ maxWidth: '536px', height: 'auto' }}

      //classes={{ root: classes.TextField }}
      />
    </div>
  );
};

export default TextBox;
